import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  RestStageCollectionListRequest,
  StageCollectionBean,
  StageCollectionLineBean,
  StageCollectionSearchCriteria,
  StageTypeBean,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  NumberFormatInputbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";

class StageCollectionListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }

  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  editStageCollection = (e, val, rowData) => {
    if (e.detail === 1) this.props.editStageCollection(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };

  render() {
    let stageCollection_list = this.props.stageCollection_list;
    let stageCollectionData = this.props.stageCollectionData;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">Stage Collection</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                type="text"
                name="code"
                onChange={this.onChange}
                value={stageCollectionData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isApplied")}>
                  Applied
                  {this.props.order === "desc" &&
                  this.props.sortField === "isApplied" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {stageCollection_list.map((Info, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.editStageCollection(e, Info.code, Info)
                      }
                    >
                      {Info.code}
                    </Button>
                  </td>

                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isApplied}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {stageCollection_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class StageCollectionEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  onLineChange = (e) => {
    this.props.onLineChange(e);
  };

  addOrUpdateLines = (e) => {
    if (e.detail === 1) this.props.addOrUpdateLines();
  };
  clearLineValues = (e) => {
    if (e.detail === 1) this.props.clearLineValues();
  };
  getLineDetails = (e, rowData) => {
    if (e.detail === 1) {
      this.props.getLineDetails(rowData);
      this.setState({
        isLineEditMode: true,
      });
    }
  };
  removeLines = (e, rowData) => {
    if (e.detail === 1) this.props.removeLines(rowData);
  };
  handleSortingStageChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingStageChange(accessor);
  };

  render() {
    let stageCollectionData = this.props.stageCollectionData;
    let stageCollectionLineData = this.props.stageCollectionLineData;
    let stageCollectionLinesList = this.props.stageCollectionData.lines;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Company Code</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="companyCode"
                type="text"
                placeholder="Enter CompanyCode"
                onChange={this.onChange}
                value={stageCollectionData.companyCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Code</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                ref={this.codeRef}
                name="code"
                type="text"
                placeholder="Enter StageCollectionCode"
                onChange={this.onChange}
                value={stageCollectionData.code}
                style={{ "text-transform": "uppercase" }}
                disabled={isDisableFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Name</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="description"
                type="text"
                placeholder="Enter Name"
                onChange={this.onChange}
                value={stageCollectionData.description}
                style={{ "text-transform": "capitalize" }}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Applied</FormLabel>
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                type="checkbox"
                name="isApplied"
                onChange={this.onChange}
                checked={stageCollectionData.isApplied}
              />
            </Col>
          </Row>

          <br />
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th
                  onClick={(e) => this.handleSortingStageChange(e, "stageCode")}
                >
                  Stage Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "stageCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStageChange(e, "description")
                  }
                >
                  Stage Description
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingStageChange(e, "duration")}
                >
                  Duration
                  {this.props.order === "desc" &&
                  this.props.sortField === "duration" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingStageChange(e, "leadTime")}
                >
                  LeadTime
                  {this.props.order === "desc" &&
                  this.props.sortField === "leadTime" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStageChange(e, "orderSequence")
                  }
                >
                  Ord.Sequence
                  {this.props.order === "desc" &&
                  this.props.sortField === "orderSequence" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingStageChange(e, "isActive")}
                >
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {stageCollectionLinesList.map((list, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.getLineDetails(e, list)}
                    >
                      {list.stageCode}
                    </Button>
                  </td>
                  <td>{list.description}</td>
                  <td>{list.duration}</td>
                  <td>{list.leadTime}</td>
                  <td>{list.orderSequence}</td>
                  <td>{list.isActive}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {stageCollectionLinesList.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
        <br />
        <br />

        <div>
          <div className="professional_details">
            <Row>
              <Col sm="1">
                <FormLabel> Stage Detail</FormLabel>
              </Col>
              <Col sm="2">
                <Button
                  id="fabric_Add_Button"
                  className="text-center"
                  onClick={(e) => this.removeLines(e, stageCollectionLineData)}
                  disabled={this.props.isDisableButton}
                >
                  {" "}
                  Remove Lines
                </Button>
              </Col>
            </Row>
            <hr class="row_border"></hr>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Stage Code</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  ref={this.props.stageCodeRef}
                  onChange={this.onLineChange}
                  name="stageCode"
                  placeholder="Enter StageCode"
                  value={stageCollectionLineData.stageCode}
                  disabled={this.props.isShowStageCode}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>StageCollection Name</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="description"
                  type="text"
                  ref={this.props.stageCollectionNameRef}
                  placeholder="Enter StageCollectionName"
                  onChange={this.onLineChange}
                  value={stageCollectionLineData.description}
                  style={{ "text-transform": "uppercase" }}
                  isMandatory={true}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Order Sequence</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <NumberFormatInputbox
                  name="orderSequence"
                  type="text"
                  ref={this.props.orderSequenceRef}
                  placeholder="Enter StageCollectionCode"
                  onChange={this.onLineChange}
                  value={stageCollectionLineData.orderSequence}
                  style={{ "text-transform": "uppercase" }}
                  isMandatory={true}
                />{" "}
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Duration in Days</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <NumberFormatInputbox
                  ref={this.props.durationRef}
                  name="duration"
                  type="text"
                  placeholder="Enter StageCollectionCode"
                  onChange={this.onLineChange}
                  value={stageCollectionLineData.duration}
                  style={{ "text-transform": "uppercase" }}
                  isMandatory={true}
                />{" "}
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Lead Time in Days</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <NumberFormatInputbox
                  ref={this.props.leadTimeRef}
                  name="leadTime"
                  type="text"
                  placeholder="Enter StageCollectionCode"
                  onChange={this.onLineChange}
                  value={stageCollectionLineData.leadTime}
                  style={{ "text-transform": "uppercase" }}
                  isMandatory={true}
                />{" "}
              </Col>
              <Col sm="1">
                <FormLabel>Applied</FormLabel>
              </Col>
              <Col sm="1">
                {" "}
                <InputCheckbox
                  type="checkbox"
                  name="isActive"
                  onChange={this.onLineChange}
                  checked={stageCollectionLineData.isActive}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  id="fabric_Add_Button"
                  className="text-center"
                  onClick={(e) => this.addOrUpdateLines(e)}
                >
                  {" "}
                  Add/Update{" "}
                </Button>
                <Button
                  id="fabric_Add_Button"
                  className="text-center"
                  onClick={(e) => this.clearLineValues(e)}
                >
                  {" "}
                  Clear{" "}
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

class StageCollectionList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.stageCodeRef = React.createRef();
    this.stageCollectionNameRef = React.createRef();
    this.orderSequenceRef = React.createRef();
    this.durationRef = React.createRef();
    this.leadTimeRef = React.createRef();
    this.state = {
      stageCollection_list: [],
      response: {},
      pageTitle: "Stage Collection",
      stageCollectionData: new StageCollectionBean(),
      stageCollectionLineData: new StageCollectionLineBean(),
      pageList: new PageListBean(),
      criteria: new StageCollectionSearchCriteria(),
      stageCollectionLinesList: [],
      isLineEditMode: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isStageCollectionListFormOpen: true,
      isStageCollectionEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      isShowStageCode: false,
      isDisableButton: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let stageCollectionData = new StageCollectionBean();
    stageCollectionData.companyCode = this.companyCode;
    this.setState({ stageCollectionData: stageCollectionData });
    this.loadPage(1);
    this.cleardata();
  }
  moduleCaption = "Stage Collection";

  cleardata = () => {
    let stageCollectionData = new StageCollectionBean();
    stageCollectionData.companyCode = this.companyCode;
    this.setState({ stageCollectionData: stageCollectionData });
  };

  saveStageCollectionResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeStageCollectionEntryForm();
  };

  saveStageCollection = () => {
    let input = this.state.stageCollectionData;
    if (input.isFetched == true) {
      if (SecurityAccessManager.StageCollectionMaintenanceEdit_IsAccessible()) {
        MasterService.updateStageCollection(
          input,
          this.saveStageCollectionResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.StageCollectionMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createStageCollection(
          input,
          this.saveStageCollectionResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editStageCollectionResponse = (response) => {
    if (response.data != null) {
      if (response.data.stageCollection != null) {
        let stageCollection = response.data.stageCollection;
        let stageCollectionLines = new Array();
        if (!isEmptyArray(response.data.stageCollection.lines)) {
          stageCollectionLines = response.data.stageCollection.lines;
          stageCollectionLines.map((Info) => {
            if (Info.isActive == true) {
              Info.isActive = "True";
            } else {
              Info.isActive = "False";
            }
          });
        }
        this.setState({
          stageCollectionData: stageCollection,
          stageCollectionLinesList: stageCollectionLines,
        });
        this.disable();
      }
      this.openStageCollectionEntryForm();
    }
  };

  editStageCollection = (code) => {
    this.clearLineValues();
    let readrestInput = new StageCollectionSearchCriteria();
    readrestInput.companyCode = this.companyCode;
    readrestInput.stageCollectionCode = code;
    if (SecurityAccessManager.StageCollectionMaintenanceView_IsAccessible()) {
      MasterService.readStageCollection(
        readrestInput,
        this.editStageCollectionResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  opentypeforms = () => {
    let stageCollectionData = this.state.stageCollectionData;
    this.editStageCollection(stageCollectionData.code);
  };

  onChange = (e) => {
    let stageCollectionData = this.state.stageCollectionData;
    stageCollectionData[e.target.name] = e.target.value;
    this.setState({ stageCollectionData: stageCollectionData });
  };
  onLineChange = (e) => {
    let stageCollectionLineData = this.state.stageCollectionLineData;
    stageCollectionLineData[e.target.name] = e.target.value;
    this.setState({
      stageCollectionLineData: stageCollectionLineData,
    });
  };
  addOrUpdateLines = () => {
    let stageCollectionData = this.state.stageCollectionData;
    let lineData = this.state.stageCollectionLineData;
    lineData.stageCollectionCode = stageCollectionData.code;
    lineData.companyCode = this.companyCode;
    if (lineData.isActive == true) {
      lineData.isActive = "True";
    } else {
      lineData.isActive = "False";
    }
    if (!isEmpty(lineData.stageCode)) {
      let existingLine = this.getLineByStageCode(lineData.stageCode);
      if (existingLine === null) {
        let stgLines = new Array();
        stgLines.push(lineData);
        if (
          stageCollectionData.lines == null ||
          stageCollectionData.lines.length == 0
        ) {
          stageCollectionData.lines = stgLines;
        } else {
          stageCollectionData.lines.push(lineData);
        }
      } else {
        const index = stageCollectionData.lines.findIndex(
          (ln) => ln.stageCode === existingLine.stageCode
        );
        if (index != -1) {
          stageCollectionData.lines.splice(index, 1);
          stageCollectionData.lines.push(lineData);
        }
      }
      this.setState({
        stageCollectionData: stageCollectionData,
      });
      this.clearLineValues();
    } else {
      let errMsg = "Invalid StageCode!";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  getLineByStageCode = (stageCode) => {
    let stgLine = null;
    let stgDetails = this.state.stageCollectionData.lines;
    if (stgDetails === null) return stgLine;
    else {
      stgDetails.map((lines) => {
        if (lines.stageCode === stageCode) {
          stgLine = lines;
          return stgLine;
        }
      });
    }
    return stgLine;
  };
  clearLineValues = () => {
    let stageCollectionLineData = new StageCollectionLineBean();
    stageCollectionLineData.companyCode = this.companyCode;
    this.setState({
      stageCollectionLineData: stageCollectionLineData,
      isShowStageCode: false,
      isDisableButton: false,
    });
  };
  removeLines = (rowData) => {
    if (!isEmptyString(rowData.stageCode) && rowData.isFetched === false) {
      let stageCollectionData = this.state.stageCollectionData;
      const index = stageCollectionData.lines.findIndex(
        (ln) => ln.stageCode === rowData.stageCode
      );
      if (index != -1) {
        stageCollectionData.lines.splice(index, 1);
      }
      this.clearLineValues();
    }
  };

  getLineDetails = (rowData) => {
    let lineData = { ...rowData };
    let stageCollectionLineData = this.state.stageCollectionLineData;
    stageCollectionLineData = lineData;
    this.setState({
      stageCollectionLineData: stageCollectionLineData,
      isShowStageCode: true,
      isDisableButton: true,
    });
    if (lineData.isFetched === false) {
      this.setState({
        isDisableButton: false,
      });
    }
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let stageCollectionData = this.state.stageCollectionData;
    stageCollectionData.companyCode = this.companyCode;
    stageCollectionData.code =
      this.state.stageCollectionData.code.toUpperCase();
    let stageLines = stageCollectionData.lines;
    for (let list of stageLines) {
      let stageType = new StageTypeBean();
      stageType.companyCode = this.companyCode;
      stageType.code = list.stageCode;
      stageType.isFetched = list.isFetched;
      stageType.description = list.description;
      list.stageType = stageType;
      stageLines = list;
    }
    this.clearError();
    this.saveStageCollection();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeStageCollectionEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openStageCollectionEntryForm = () => {
    this.setState({
      isStageCollectionListFormOpen: false,
      isStageCollectionEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeStageCollectionEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isStageCollectionListFormOpen: true,
      isStageCollectionEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadStageCollectionResponse = (response) => {
    if (response.data != null && response.data.collectionPageList != null) {
      let stageCollections = new Array();
      if (!isEmptyArray(response.data.collectionPageList.stageCollections)) {
        stageCollections = response.data.collectionPageList.stageCollections;
        stageCollections.map((Info) => {
          if (Info.isApplied == true) {
            Info.isApplied = "True";
          } else {
            Info.isApplied = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount = response.data.collectionPageList.totalCount;
      pageList.currentPage = response.data.collectionPageList.currentPage;
      pageList.pageSize = response.data.collectionPageList.pageSize;
      this.setState({
        stageCollection_list: stageCollections,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new StageCollectionSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadStageCollectionPage(pageInput, criteria);
  };

  loadStageCollectionPage = (pageList, criteria) => {
    let requestInput = new RestStageCollectionListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.StageCollectionMaintenanceView_IsAccessible) {
      MasterService.getStageCollections(
        requestInput,
        this.loadStageCollectionResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.stageCollection_list;
    if (sortField) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ stageCollection_list: sorted });
    }
  };

  handleSortingStageChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingStage(sortField, sortOrder);
  };
  handleSortingStage = (sortField, sortOrder) => {
    let list = this.state.stageCollectionLinesList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ stageCollectionLinesList: sorted });
    }
  };

  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isStageCollectionListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isStageCollectionListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isStageCollectionListFormOpen && (
          <StageCollectionListForm
            {...this.state}
            onChange={this.onChange}
            editStageCollection={this.editStageCollection}
            opentypeforms={this.opentypeforms}
            enterKeyEventHandler={this.enterKeyEventHandler}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isStageCollectionEntryFormOpen && (
          <StageCollectionEntryForm
            {...this.state}
            saveStageCollection={this.saveStageCollection}
            editStageCollection={this.editStageCollection}
            onChange={this.onChange}
            onLineChange={this.onLineChange}
            addOrUpdateLines={this.addOrUpdateLines}
            getLineDetails={this.getLineDetails}
            clearLineValues={this.clearLineValues}
            removeLines={this.removeLines}
            handleSortingStageChange={this.handleSortingStageChange}
          />
        )}
      </div>
    );
  }
}

function StageCollectionAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <StageCollectionList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default StageCollectionAttributeModule;
